import { Suspense } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { PageSpinner } from "@impero-com/ui";
import { useNavigate } from "react-router-dom";

import { OrgApplicationBar } from "../../components/applicationBar/orgApplicationBar";
import { LegacyRoute } from "../../legacyRoutes";
import { WebRoute } from "../../routes";
import { navigateTo } from "../../utils/legacyNavigation";
import { MenuBadgeWrapper } from "../dashboard/components/MenuBadgeWrapper";
import { dashboardPendingActivitiesUrl } from "../dashboardPendingActivities/urlUtils";

import { ControlHealthContainer } from "./ControlHealthContainer";

interface ControlHealthPageProps {
    isNewDashboard: boolean;
}

export function ControlHealthPage({ isNewDashboard }: ControlHealthPageProps) {
    return (
        <Suspense fallback={<PageSpinner />}>
            <ControlHealthPageContent isNewDashboard={isNewDashboard} />
        </Suspense>
    );
}

function ControlHealthPageContent({ isNewDashboard }: ControlHealthPageProps) {
    const { t } = useTranslation();

    //Application Bar
    const navigate = useNavigate();

    return (
        <OrgApplicationBar
            title={t(
                isNewDashboard ? "Dashboard_Title" : "ControlHealth_Title"
            )}
            navigation={
                isNewDashboard
                    ? undefined
                    : {
                          type: "Tabs",
                          currentTabId: "tab-control-health",
                          tabSpecs: [
                              {
                                  id: "tab-overview",
                                  label: t("Dashboard_Title_V2"),
                                  onClick: () =>
                                      navigate(WebRoute.DASHBOARD_V2),
                              },
                              {
                                  id: "tab-control-health",
                                  label: t("ControlHealth_Title"),
                                  onClick: () =>
                                      navigate(WebRoute.CONTROL_HEALTH),
                              },
                              {
                                  id: "tab-dashboard",
                                  label: t("Dashboard_ControlPrograms_Title"),
                                  onClick: () =>
                                      navigateTo(
                                          LegacyRoute.DASHBOARD_NO_REDIRECT
                                      ),
                              },
                              {
                                  id: "tab-pending-actions",
                                  label: <MenuBadgeWrapper />,
                                  onClick: () =>
                                      navigate(dashboardPendingActivitiesUrl),
                              },
                          ],
                      }
            }
        >
            <ControlHealthContainer isNewDashboard={isNewDashboard} />
        </OrgApplicationBar>
    );
}
